import * as THREE from 'three';

export const PREVIEW_BACKGROUND_COLOR = 0xe9f2f7;
export const PREVIEW_FLOOR_SIZE = 8;
const PREVIEW_FLOOR_TILE_COUNT = 60;
const PREVIEW_GRID_TEXTURE_SIZE = 32;

export const createPreviewFloor = () => {
  const pixels = new Uint8Array(PREVIEW_GRID_TEXTURE_SIZE * PREVIEW_GRID_TEXTURE_SIZE * 4);
  for (let y = 0; y < PREVIEW_GRID_TEXTURE_SIZE; y += 1) {
    for (let x = 0; x < PREVIEW_GRID_TEXTURE_SIZE; x += 1) {
      const alphaIndex = (y * PREVIEW_GRID_TEXTURE_SIZE + x) * 4 + 3;
      pixels[alphaIndex] = x === 0 || y === 0 ? 255 : 0;
    }
  }
  const texture = new THREE.DataTexture(
    pixels,
    PREVIEW_GRID_TEXTURE_SIZE,
    PREVIEW_GRID_TEXTURE_SIZE,
    THREE.RGBAFormat,
  );
  texture.colorSpace = THREE.SRGBColorSpace;
  texture.wrapS = THREE.RepeatWrapping;
  texture.wrapT = THREE.RepeatWrapping;
  texture.repeat.set(PREVIEW_FLOOR_TILE_COUNT / 2, PREVIEW_FLOOR_TILE_COUNT / 2);
  texture.magFilter = THREE.NearestFilter;
  texture.minFilter = THREE.LinearMipmapLinearFilter;
  texture.generateMipmaps = true;
  texture.needsUpdate = true;

  const floor = new THREE.Mesh(
    new THREE.PlaneGeometry(PREVIEW_FLOOR_SIZE, PREVIEW_FLOOR_SIZE),
    new THREE.MeshBasicMaterial({
      map: texture,
      transparent: true,
      opacity: 0.35,
      depthWrite: false,
    }),
  );
  floor.name = 'FILO_PREVIEW_FLOOR';
  floor.position.z = -0.002;
  floor.receiveShadow = true;
  return floor;
};

export const disposePreviewFloor = (floor: THREE.Mesh<THREE.PlaneGeometry, THREE.MeshBasicMaterial>) => {
  floor.geometry.dispose();
  floor.material.map?.dispose();
  floor.material.dispose();
};